import routerOptions0 from "/builds/devhacker/lh-website-client/node_modules/.pnpm/nuxt@3.17.5_@parcel+watcher@2.5.0_@types+node@22.15.17_db0@0.3.2_eslint@9.39.2_jiti@2.4_e4640a7bd66a3e4e181546c577e2f4bc/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}